import { render } from "./ResultResponse.vue?vue&type=template&id=fc2e6a96&scoped=true&ts=true"
import script from "./ResultResponse.ts?vue&type=script&lang=ts"
export * from "./ResultResponse.ts?vue&type=script&lang=ts"

import "./ResultResponse.scss?vue&type=style&index=0&id=fc2e6a96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2e6a96"]])

export default __exports__